var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5V19.5C20.2495 19.8977 20.0914 20.279 19.8102 20.5602C19.529 20.8414 19.1477 20.9995 18.75 21H15.375C14.9773 20.9995 14.596 20.8414 14.3148 20.5602C14.0336 20.279 13.8755 19.8977 13.875 19.5V4.5C13.8755 4.10231 14.0336 3.72105 14.3148 3.43984C14.596 3.15864 14.9773 3.00045 15.375 3H18.75C19.1477 3.00045 19.529 3.15864 19.8102 3.43984C20.0914 3.72105 20.2495 4.10231 20.25 4.5V4.5ZM8.625 3H5.25C4.85231 3.00045 4.47105 3.15864 4.18984 3.43984C3.90864 3.72105 3.75045 4.10231 3.75 4.5V19.5C3.75045 19.8977 3.90864 20.279 4.18984 20.5602C4.47105 20.8414 4.85231 20.9995 5.25 21H8.625C9.02269 20.9995 9.40395 20.8414 9.68516 20.5602C9.96636 20.279 10.1245 19.8977 10.125 19.5V4.5C10.1245 4.10231 9.96636 3.72105 9.68516 3.43984C9.40395 3.15864 9.02269 3.00045 8.625 3V3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButton);
export default __webpack_public_path__ + "static/media/pause_button.2f9e95f07835ff74a26f0cd71995bfd7.svg";
export { ForwardRef as ReactComponent };